import React from "react";
import { useTranslation } from "react-i18next";
import { Tooltip } from "@mui/material";
import { Chip } from "@outpave/ds";
import { Inline } from "components/layout/reusableLayouts";
import { restrictionEntryLabel } from "utils/cards/cardFormUtils";
import { EMPTY_CELL, type RestrictionEntry } from "utils/cards/cardRowData";

const SHOWN = 2;

const isBlocked = (type: string) =>
  type === "blocked" || type === "blockedCategory";

/** The merchant and category restrictions on a card, as chips. */
export const CardRestrictionsCell: React.FC<{ items: RestrictionEntry[] }> = ({
  items,
}) => {
  const { t } = useTranslation();

  if (items.length === 0) {
    return (
      <span style={{ color: "var(--color-text-tertiary)" }}>{EMPTY_CELL}</span>
    );
  }

  const shown = items.slice(0, SHOWN);
  const hidden = items.slice(SHOWN);

  return (
    <Inline gap="var(--space-2)">
      {shown.map((item, index) => (
        <Chip
          key={`${index}-${item.type}-${item.name}`}
          size="sm"
          tone={isBlocked(item.type) ? "negative" : "neutral"}
        >
          {restrictionEntryLabel(item, t)}
        </Chip>
      ))}
      {hidden.length > 0 && (
        <Tooltip
          title={hidden
            .map((item) => restrictionEntryLabel(item, t))
            .join(", ")}
          placement="top"
        >
          <span>
            <Chip size="sm" tone="neutral">{`+${hidden.length}`}</Chip>
          </span>
        </Tooltip>
      )}
    </Inline>
  );
};

export default CardRestrictionsCell;
